import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
// import CircumstanceManager from '../Circumstance/CircumstanceManager';
import ProjectDetail from './ProjectDetail';
import ProjectItem from './ProjectItem';
import ProjectPanel from './ProjectPanel';
import DocumentPanel from '../../common/document/DocumentPanel';
import CircumstanceManager from '../Circumstance/CircumstanceManager';
import styles from '../../../../components/Display/Wrapper.module.scss';


function ProjectPage({ isActive }) {
  const { setActiveView, navigationContext } = useNavigationContext();
  const [projectList, setProjectList] = useState([]);
  const { accountContext } = useAccountContext();
  const [projectDetail, setProjectDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documentManagerIsOpen, setDocumentManagerIsOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(undefined);
  const [imageScrolling, setImageScrolling] = useState(false);
  const [circumstanceManagerIsOpen, setCircumstanceManagerIsOpen] = useState(false);
  const [selectedCircumstance, setSelectedCircumstance] = useState(undefined);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    if (navigationContext.activeProjectId) {
      fetchProjectDetail();
    } else setProjectDetail(undefined);
  }, [navigationContext]);

  useEffect(() => {
    fetchProjectList();
  }, []);

  const fetchProjectList = async () => {
    await privateFetch('GET', 'prna', `/cu/${accountContext.id}/project/`).then((res) => {
      setProjectList(res);
    });
  };

  const fetchProjectDetail = async () => {
    await privateFetch(
      'GET',
      'prna',
      `/cu/${accountContext.id}/project/${navigationContext.activeProjectId}`
    ).then((res) => {
      if (res) setProjectDetail(res);
    });
  };

  const createProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'prna',
      `/cu/${accountContext.id}/project/`,
      'Le projet a bien été ajouté',
      JSON.stringify(projectForm)
    ).then((res) => {
      fetchProjectList();
      setPanelIsOpen(false);
      setImageScrolling(false);
      setLoading(false);
      setActiveView('prnaproject', res, 'activeProjectId');
    });
  };

  const updateProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'prna',
      `/cu/${accountContext.id}/project/${projectDetail.id}/`,
      'Le projet a bien été modifié',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      fetchProjectDetail(projectDetail.id);
      setLoading(false);
      setImageScrolling(false);
    });
  };

  const handleDeleteProject = async (project) => {
    await privateFetch(
      'DELETE',
      'prna',
      `/cu/${accountContext.id}/project/${project.id}/`,
      'Le projet a bien été supprimé'
    ).then(() => {
      fetchProjectList();
      setProjectDetail(undefined);
    });
  };

  const deleteCircumstance = async (circumstance) => {
    await privateFetch(
      'DELETE',
      'prna',
      `/cu/${accountContext.id}/circumstance/${circumstance.id}/`,
      'La circonstance a bien été supprimée'
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();
      setSelectedCircumstance(undefined);
    });
  };

  const createProjectCircumstance = async (circonstanceForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'prna',
      `/cu/${accountContext.id}/project/${projectDetail.id}/circumstance/`,
      'La circonstance a bien été enregistrée',
      JSON.stringify(circonstanceForm)
    ).then((res) => {
      fetchProjectList();
      fetchProjectDetail();
      setLoading(false);
      setCircumstanceManagerIsOpen(false);
    });
  };

  const handleCreateCircumstance = () => {
    setSelectedCircumstance(undefined);
    setCircumstanceManagerIsOpen(true);
  };

  const updateCircumstance = async (circumstanceForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'prna',
      `/cu/${accountContext.id}/circumstance/${selectedCircumstance.id}/`,
      'La circonstance a bien été modifiée',
      JSON.stringify(circumstanceForm)
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();
      setLoading(false);
      setCircumstanceManagerIsOpen(false);
    });
  };

  const handleClickProject = (project) => {
    setActiveView('prnaproject', project, 'activeProjectId');
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const handleUpdateImage = () => {
    setPanelIsOpen(true);
    setImageScrolling(true);
  };

  const newProjectAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un projet',
    icon: 'pi-plus'
  };

  const goBackProjectAction = {
    onClick: handleClickProject,
    icon: 'pi-chevron-left',
    label: 'Retour à la liste'
  };

  const handleCreateDocument = () => {
    setSelectedDocument(undefined);
    setDocumentManagerIsOpen(true);
  };

  const handleUpdateDocument = (document) => {
    setSelectedDocument(document);
    setDocumentManagerIsOpen(true);
  };

  const uploadProjectDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'prna',
      `/cu/${accountContext.id}/project/${projectDetail.id}/file/`,
      'Le fichier a bien été enregistré',
      documentForm,
      false,
      true
    ).then(() => {
      fetchProjectDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const updateDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/file/${selectedDocument.id}/`,
      'Le document a bien été modifié',
      documentForm,
      false,
      true
    ).then(() => {
      fetchProjectDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const handleDeleteDocument = async (document) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/file/${document.id}/`,
      'Le document a bien été supprimé'
    ).then(() => {
      fetchProjectDetail();
      setSelectedDocument(undefined);
    });
  };

  const handleOrderChange = async (project, index) => {
    await privateFetch(
      'PUT',
      'prna',
      `/cu/${accountContext.id}/project/${project.id}/order/?index=${index}`
    ).then(() => {
      fetchProjectList();
    });
  };

  const handleCircumstanceOrderChange = async (crc, index) => {
    await privateFetch(
      'PUT',
      'prna',
      `/cu/${accountContext.id}/circumstance/${crc.id}/order/?index=${index}`
    ).then(() => {
      fetchProjectList();
      fetchProjectDetail();
    });
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == 'grid' ? 'pi-list' : 'pi-th-large'
  };



  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Projets"
        labelAction={handleClickProject}
        actions={projectDetail ? [goBackProjectAction] : [changeLayoutAction, newProjectAction]}
        detail={projectDetail}>
        {!projectDetail ? (
          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {projectList.map((project, index) => (
                <ProjectItem
                  layout={layout}
                  key={index}
                  project={project}
                  handleClickProject={() => (handleClickProject(project), console.log('CLIKED'))}
                  onChange={handleOrderChange}
                  currentOrder={index}
                />
              ))}
            </div>
          </div>
        ) : (
          <ProjectDetail
            project={projectDetail}
            handleUpdateProject={handleOpenManager}
            handleDelete={handleDeleteProject}
            handleCreateFile={handleCreateDocument}
            handleUpdateFile={handleUpdateDocument}
            handleDeleteFile={handleDeleteDocument}
            handleCreateCircumstance={handleCreateCircumstance}
            handleDeleteCircumstance={deleteCircumstance}
            onSelectCircumstance={(crc) => {
              setSelectedCircumstance(crc);
              setCircumstanceManagerIsOpen(true);
            }}
            handleUpdateImage={handleUpdateImage}
            handleCircumstanceOrderChange={handleCircumstanceOrderChange}
          />
        )}
        <ProjectPanel
          isOpen={panelIsOpen}
          onClose={() => (setPanelIsOpen(false), setImageScrolling(false))}
          project={projectDetail}
          onCreate={createProject}
          onUpdate={updateProject}
          loading={loading}
          imageScrolling={imageScrolling}
        />
      </PageWrapper>

      <CircumstanceManager
        isOpen={circumstanceManagerIsOpen}
        onClose={() => {
          setSelectedCircumstance(undefined);
          setCircumstanceManagerIsOpen(false);
        }}
        circumstance={selectedCircumstance}
        onCreate={createProjectCircumstance}
        onUpdate={updateCircumstance}
        onDelete={deleteCircumstance}
        loading={loading}
        isProject
      />
      <DocumentPanel
        document={selectedDocument}
        loading={loading}
        isOpen={documentManagerIsOpen}
        onClose={() => {
          setSelectedDocument(null);
          setDocumentManagerIsOpen(false);
        }}
        onCreate={uploadProjectDocument}
        onUpdate={updateDocument}
      />
    </div>
  );
}

export default ProjectPage;
